import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="w-full bg-slate-100 px-5 py-10" data-id="element-91" data-mp="4uqdmw6js2tb">
      <div className="mx-auto max-w-[680px] rounded-lg border border-slate-200 bg-white p-5 text-center sm:p-6" data-id="element-92" data-mp="4xcksupj0gb0">
        <h2 className="flex items-center justify-center gap-2.5 text-[1.1rem] font-extrabold uppercase leading-tight tracking-tight text-slate-950 sm:text-[1.25rem]" data-id="element-93" data-mp="etfwosa6jtb5">
          <ShieldCheckIcon className="h-5 w-5 shrink-0 text-orange-700" aria-hidden="true" data-id="element-94" data-mp="js0vcn9sa4xh" />
          Your Purchase Is Protected
        </h2>
        <p className="mx-auto mt-3 max-w-[580px] text-[1rem] leading-relaxed text-slate-950" data-id="element-95" data-mp="slvsp94nyr2k">
          Try{' '}
          <strong className="font-extrabold" data-id="element-96" data-mp="xjfh31v2sk88">FINANCIAL LITERACY READY™</strong>{' '}
          and explore the complete system, all six volumes, and all five
          included bonuses.
        </p>
        <p className="mx-auto mt-3 max-w-[580px] text-[1rem] leading-relaxed text-slate-950" data-id="element-97" data-mp="17iwih73aobye">
          If the material is not right for you or does not meet your
          expectations, contact us within 7 days and request a refund according
          to the applicable guarantee terms.
        </p>
        <p className="mt-3 text-[0.95rem] font-extrabold uppercase tracking-tight text-slate-950" data-id="element-98" data-mp="1vuiwwzutyrch">
          No subscription. One payment. Instant access.
        </p>
      </div>
    </section>;
}